<template>
  <div class="su-page" :style="{background:bg}">
    <div class="flex al-cn cl999 f13 ml15">
      当前位置：
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
            v-for="(item,index) in $route.matched"
            :key="index"
            :to="{ path: item.path == '' ? '/home' : item.path}">
          {{ item.meta.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="mt15 su-page-content">
      <div class="leftNavigation mb20" v-if="list && list.length > 0">
        <div
            class="leftNavigation-item flex al-cn"
            :style="{background:parentRoute2 == item.path ? '#F7EFEF' : ''}"
            v-for="(item,index) in list"
            :key="index"
            @click="routerGo(item.path)">
          <div v-if="parentRoute2 == item.path" class="leftNavigation-leftIcon"/>
          <div class="f16 leftNavigation-item-name" :class="{clC32912:parentRoute2 == item.path}">
            {{ item.meta.title }}
          </div>
        </div>
      </div>
      <div v-else></div>
      <div class="mb20">
        <div class="su-card rightData">
          <su-title :title="title1" :more="false"/>
          <slot name="content"/>
        </div>
        <slot name="bottom"/>
      </div>
    </div>
  </div>
</template>

<script>
// 导入路由配置
import kejianrouter from '@/router';
import {loginOut} from "@/api/api";

export default {
  name: "su-page",
  props: {
    title: {
      type: String,
      default: ''
    },
    bg: {
      type: String,
      // default: 'rgba(255,255,255,0)' //透明背景
      default: '#f7f7f7'
    }
  },
  data() {
    return {
      parentRoute: '', // 父级路由
      parentRoute2: '',
      parentRoute3: '',
      typeIndex: '', // 当前路由
      title1: this.title ? this.title : this.$route.meta.title,
      list: [],
      breadList: [] // 路由集合
    };
  },
  watch: {
    $route() {

    }
  },
  mounted() {
    //字符串，用/分隔取第一个
    this.typeIndex = this.$route.fullPath
    let fullPath = this.$route.fullPath.split('/')
    this.parentRoute = '/' + fullPath[1]
    this.parentRoute2 = fullPath[2]
    if (fullPath[3]) {
      this.parentRoute3 = fullPath[3]
    }
    if (this.$route.meta.title !== '搜索详情') {
      this.list = this.getAllRoutes(kejianrouter.options.routes[0].children, this.parentRoute)
    }
  },
  methods: {
    // 路由跳转
    routerGo(path) {
      let then = this
      if (path === 'logOut') {
        //是否确认退出登录
        this.$confirm('确认要退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'custom-confirm-dialog',
          type: 'warning'
        }).then(() => {
          // 退出登录
          loginOut().then(res => {
            if (res.status === 200) {
              then.$message.warning('退出成功')
              //清除缓存
              then.$store.commit('logout')
              then.$router.push({name: 'home'})
            }
          })
        }).catch(() => {

        });
      } else if (path && path !== this.typeIndex) {
        this.$router.push({path: this.parentRoute + '/' + path});
      }
    },
    // 获取所有路由.处理数据
    getAllRoutes(routes = [], fullPath) {
      let allRoutes = [];
      routes.forEach(route => {
        if (route.path === fullPath) {
          allRoutes = route.children || [];
          if (!this.title && route.children && route.children.length > 0) {
            route.children.forEach(childRoute => {
              if (childRoute.path === this.parentRoute2) {
                this.title1 = childRoute.meta.title;
              }
            });
          }
        }
      });
      return allRoutes;
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 750px) {
  .custom-confirm-dialog {
    width: 300px; /* 设置你想要的宽度 */
  }
}

.su-page {
  box-sizing: border-box;
  width: 100%;
  line-height: 1.15;
  font-size: 16px;

  .leftNavigation {
    background: #fff;
    border-radius: 10px;

    &-leftIcon {
      width: 4px;
      height: 35px;
      background: #C32912;
    }

    &-item {
      height: 50px;

      &-name {
        margin-left: 30px;
      }

      &:hover {
        cursor: pointer;
        background: #F7EFEF;
      }
    }
  }

  .rightData {
    padding: 30px 50px;
    min-height: 50vh;
  }
}

@media (min-width: 750px) {
  .su-page-content {
    grid-column-gap: 10px;
    display: grid;
    grid-template-columns: calc(20% - 5px) calc(80% - 5px);

  }
}

@media (max-width: 750px) {
  .su-page-content {
    .leftNavigation {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 15px 15px 0 15px;
      border-radius: 0;

      &-leftIcon {
        display: none; //隐藏
      }

      &-item {
        height: 40px;

        &-name {
          margin: 0 15px;
          font-size: 14px !important;
        }
      }
    }

    .rightData {
      border-radius: 0;
      padding: 30px 20px;
    }
  }
}
</style>
